import { combineReducers } from "redux"
import designCollection from "./file"

export default combineReducers({
  designCollection
})
